// extracted by mini-css-extract-plugin
export default {"start_writing_flex":"StartWritingButton_start_writing_flex__yUyH1"};